/* eslint-disable */

import {bus} from '@/main';
import cancelMembershipPopup from '@/components/private/package/cancel-membership-popup/'
import {mapGetters} from 'vuex';

const $ = window.jQuery = require('jquery');  
export default {
  name: 'membership-packages-page',
  components: {
    'cancel-membership' : cancelMembershipPopup
  },
  props: [],
  data () {
    return {
      isLoggedIn: null,
      selfUserInfo:null,
      getPackageListData:null,
      getPackageListDataResults:[],
      cancelMembershipPopupState:false
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters',
      'getAllPlansListGetters'
    ]),
    getUserDetailsAgainFun(){
      this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data
      return;
    },
    checkUserLogin() {
      this.isLoggedIn = this.$store.getters.isAuthenticated
      return;
    },
    getPackageListDataFunc(){
      this.getPackageListData = this.$store.getters.getAllPlansListGetters
      return;
    },
    setInitialStatesOfPlanFunc(){
      if(this.getPackageListData){
        this.getPackageListDataResults = this.getPackageListData.data
      }
      return;
    }
  },
  mounted () {
    this.checkUserLogin
    this.getPackageListDataFunc
    this.setInitialStatesOfPlanFunc
    if(this.isLoggedIn){
      this.$store.dispatch('getAcUserDetailsFun')
    }
    bus.$on('cancelMembershipPopupStateBus', (data) => {
      this.cancelMembershipPopupState = data
    })
  },
  methods: {
    cancelMembershipPopupOpen(){
      this.cancelMembershipPopupState = true
      document.body.classList.add('body_right_scroll_remove')
    }
  },
  watch: {
    getUserDetailsAgainFun(){
      return this.$store.getters.acUserDetailsStateGetters;
    },
    checkUserLogin() {
      return this.$store.getters.isAuthenticated
    },
    getPackageListDataFunc(){
      return this.$store.getters.getAllPlansListGetters;
    },
    setInitialStatesOfPlanFunc(){
      if(this.getPackageListData){
        this.getPackageListDataResults = this.getPackageListData.data
      }
      return;
    }
  },
  beforeCreate: function() {
    $('body').addClass('left_sidebaar_disabled_for_page')
    $('body').addClass('public_page_for_wrp_img')
  },
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('left_sidebaar_disabled_for_page')
    $('body').removeClass('public_page_for_wrp_img')
    $(window).scrollTop(0);
    next();
  },
}